import { useQuery } from "@tanstack/react-query";
import { fetchGeneralApiGet } from "../utils";
import type { CrmRules } from "./types";

export type { CrmRecordTypeRules, CrmRules, CrmTagRules } from "./types";

export const crmRulesQueryKey = ["general_api", "crm", "rules"] as const;

export function getCrmRules() {
  return fetchGeneralApiGet<CrmRules>("crm/rules");
}

/** The rules query's function: the rules, or a thrown error. */
export async function fetchCrmRules(): Promise<CrmRules> {
  const response = await getCrmRules();
  if (!response.success) {
    throw new Error(response.message || "Unable to load CRM rules");
  }
  return response.data;
}

export function useGetCrmRules() {
  return useQuery({
    queryKey: crmRulesQueryKey,
    queryFn: fetchCrmRules,
    refetchOnWindowFocus: false,
  });
}
